import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAtlassianUser } from 'src/hooks/useAtlassianUser';

import { MY_LEARNING_TAB_PATHS, MyLearningTabs } from './children/MyLearningTabs';

export const MyLearningPageV2: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading: isLoadingAtlassianUser } = useAtlassianUser();

  const activeTabIndex = MY_LEARNING_TAB_PATHS.findIndex((path) => location.pathname.includes(path));

  useEffect(() => {
    if (activeTabIndex === -1 || (!isLoadingAtlassianUser && !user)) {
      navigate(`/not-found`);
    }
  }, [activeTabIndex, isLoadingAtlassianUser, navigate, user]);

  return <MyLearningTabs activeTabIndex={activeTabIndex} />;
};
